import Settings from '@engine/features/dashboard/chart/dashboard_chart_settings';
/**
 * Creates fake dataset for chart initialization
 * This prevents UI flikering while the chart loads real data
 *
 * @returns {Array} Dataset
 */

function dataset() {
  var data = new Array(Settings.DATA_PERIOD + 1);

  for (var i = 0; i < data.length; i += 1) {
    data[i] = {
      x: moment().subtract(i, 'days').format(Settings.DATE_FORMAT),
      y: 0
    };
  }

  return data.reverse();
}
/**
 * Gets selected UI currency code
 *
 * @return {String} BGN/EUR & etc.
 */


function currency() {
  return $('#chart-currency').val() || '';
}
/**
 * Converts timestamps into human readable date
 *
 * @param {Number} time Date timestamp
 * @return {String} LABEL_FORMAT
 */


function formatLabel(time) {
  return moment(time).format(Settings.LABEL_FORMAT);
}
/**
 * Converts timestamps into standart date format
 *
 * @param {Number} time Date timestamp
 * @return {String} DATE_FORMAT
 */


function formatDate(time) {
  return moment(time).format(Settings.DATE_FORMAT);
}
/**
 * Converts raw volume into formatted string
 * based on UI selected currency code
 *
 * @param {Number} volume Raw volume
 * @param {String} defaultCurrency
 * @return {String} Formated volume: 32.320,85 €
 */


function formatVolume(volume) {
  var defaultCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  return Intl.NumberFormat(I18n.locale, {
    style: 'currency',
    currency: currency() || defaultCurrency
  }).format(volume);
}
/**
 * Converts date into timestamp in milliseconds
 *
 * If {String} date is not passed it
 * returns today's {Number} timestamp
 *
 * @param {String} date Formated date in DATE_FORMAT
 * @return {Number} Timestamp
 */


function timestamp(date) {
  return new Date(date || Date.now()).getTime();
}
/**
 * Returns a timestamp of the first date
 * from given {Number} period of days
 * counting backwards from today
 *
 * @param {Number} data_max_period Number of days
 * @return {Number} Timestamp
 */


function startTimestamp(data_max_period) {
  return moment().subtract(data_max_period, 'days').valueOf();
}
/**
 * Extracts selected date range from provided dataset
 *
 * @param {Object} input_dataset Dataset with chart's data
 * @param {Array} range_timestamps Start and end timestamps
 * @return {Object} Sliced dataset
 */


function sliceDataset(input_dataset, range_timestamps) {
  var startDate = formatDate(range_timestamps[0]);
  var endDate = formatDate(range_timestamps[1]);
  var startIndex = Settings.DEFAULT_DATE_RANGE;
  var endIndex = input_dataset.length;
  $.grep(input_dataset, function (datasetItem, index) {
    var date = datasetItem.x;

    if (date === startDate) {
      startIndex = index;
    }

    if (date === endDate) {
      endIndex = index + 1;
    }
  });
  return input_dataset.slice(startIndex, endIndex);
}

var Utility = {
  startTimestamp: startTimestamp,
  sliceDataset: sliceDataset,
  formatVolume: formatVolume,
  formatLabel: formatLabel,
  formatDate: formatDate,
  timestamp: timestamp,
  currency: currency,
  dataset: dataset
};
export default Utility;